<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/521KXd/tc-custom/9798889106616.jpg?1725723408857" alt="This image is the cover for the book The Adventures of Nick and Rosie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Adventures of Nick and Rosie
      </h1>
      <p class="bookDescription body article font2">
        <p>Join Nick and Rosie on a magical adventure to visit their best friends in the city. Come follow them as they meet new friends along the way in their adventure.</p><p>‘Today, has been quite an adventure, Nick,’ said Rosie.</p><p>‘Yes, it was, Rosie, but tomorrow will be even better,’ Nick replied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Annie Golden
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Aptos",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>Annie Golden is a first-time children&rsquo;s book author. She is a retired member of the armed services and a loving wife and mother and loves her pets. She is highly educated and well-respected. She lives with her family in the Peach State of Georgia.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d6c3312